import { LogoSpaceliftColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

const AiChatThinkingAvatarStatic = () => {
  return (
    <Box align="center" justify="center" className={styles.avatar}>
      <Icon src={LogoSpaceliftColored} />
    </Box>
  );
};

export default AiChatThinkingAvatarStatic;
